export const translations = {
  en: {
    header: {
      title: "🌟AI Study Assistant🌟",
      serverOnline: "Backend online",
      signInButton: "🔐 Sign In",
      feedback: "Feedback",
      contact: "Contact",
      chat: "Chat",
      messages: "Messages",
      resources: "Resources",
      pricing: "Pricing",
      faq: "Q&A",
      toggleTheme: "Toggle theme",
      toggleMenu: "Toggle navigation menu",
      selectLanguage: "Select language",
    },
    consent: {
      label: "Cookie consent",
      title: "Your privacy, your choice",
      message: "We use cookies to keep you signed in, remember your settings and understand how the site is used. You decide what is allowed.",
      detailsLink: "Privacy policy",
      acceptAll: "Accept all",
      rejectAll: "Continue without optional cookies",
      customize: "Customize",
      manage: "Cookie settings",
      panelTitle: "Cookie settings",
      panelIntro: "Pick what you allow. The necessary cookies always stay on: they are what keeps you signed in and the site working.",
      trackingDisabledNote: "Analytics and advertising are disabled in local development. Nothing is sent.",
      save: "Save my choices",
      cancel: "Cancel",
      necessary: "Necessary",
      necessaryDesc: "Sign-in session, security and the anonymous session cookie. Always on.",
      analytics: "Analytics",
      analyticsDesc: "Anonymous statistics (Google Tag Manager) to see which lessons are used and fix what breaks.",
      ads: "Advertising",
      adsDesc: "Ad cookies that keep the free plan free. Free plan only.",
      adsNotAvailable: "No advertising on your plan: nothing to allow.",
      preferences: "Preferences",
      preferencesDesc: "Remembers your language, theme, class and model choice on this device.",
      restricted: "Only the free resources",
      restrictedDesc: "Limits the app to the free resources page: no chat, no account, no tracking.",
      restrictedOn: "The app is limited to the free resources.",
      leaveSite: "Leave the site",
      leaveSiteDesc: "Close this tab, or come back later and change your choice.",
      back: "Back",
      alwaysOn: "Always on",
      localDataNote: "Your profile (level, age, school, city) is cached on this device for speed and is deleted when you sign out. It never leaves your browser.",
      on: "Allowed",
      off: "Off",
    },
    footer: {
      poweredBy: "Crafted by DRIHMIA | Your Personal Study Assistant",
      links: {
        faq: "Q&A",
        privacy: "Privacy",
        terms: "Terms",
        contact: "Contact",
        cookies: "Cookie settings",
      },
    },
  },
  fr: {
    header: {
      title: "🌟Assistant d'étude IA🌟",
      serverOnline: "Serveur en ligne",
      signInButton: "🔐 Se connecter",
      feedback: "Retours",
      contact: "Contacter",
      chat: "Discution",
      messages: "Messages",
      resources: "Ressources",
      pricing: "Tarifs",
      faq: "Q&R",
      toggleTheme: "Changer de thème",
      toggleMenu: "Ouvrir ou fermer le menu",
      selectLanguage: "Choisir la langue",
    },
    consent: {
      label: "Consentement aux cookies",
      title: "Votre vie privée, votre choix",
      message: "Nous utilisons des cookies pour vous garder connecté, mémoriser vos réglages et comprendre l'usage du site. Vous décidez de ce qui est autorisé.",
      detailsLink: "Politique de confidentialité",
      acceptAll: "Tout accepter",
      rejectAll: "Continuer sans cookies optionnels",
      customize: "Personnaliser",
      manage: "Gérer les cookies",
      panelTitle: "Gérer les cookies",
      panelIntro: "Choisissez ce que vous autorisez. Les cookies nécessaires restent toujours actifs : ils vous gardent connecté et le site fonctionne.",
      trackingDisabledNote: "La mesure d’audience et la publicité sont désactivées en développement local. Rien n’est envoyé.",
      save: "Enregistrer mes choix",
      cancel: "Annuler",
      necessary: "Nécessaires",
      necessaryDesc: "Session de connexion, sécurité et cookie de session anonyme. Toujours actifs.",
      analytics: "Mesure d'audience",
      analyticsDesc: "Statistiques anonymes (Google Tag Manager) pour voir quelles leçons sont utilisées et corriger ce qui casse.",
      ads: "Publicité",
      adsDesc: "Cookies publicitaires qui rendent la formule gratuite gratuite. Formule gratuite uniquement.",
      adsNotAvailable: "Aucune publicité sur votre formule : rien à autoriser.",
      preferences: "Préférences",
      preferencesDesc: "Mémorise votre langue, votre thème, votre classe et votre choix de modèle sur cet appareil.",
      restricted: "Ressources gratuites uniquement",
      restrictedDesc: "Limite l'application à la page des ressources gratuites : pas de chat, pas de compte, pas de suivi.",
      restrictedOn: "L'application est limitée aux ressources gratuites.",
      leaveSite: "Quitter le site",
      leaveSiteDesc: "Fermez cet onglet, ou revenez plus tard et changez d'avis.",
      back: "Retour",
      alwaysOn: "Toujours actifs",
      localDataNote: "Votre profil (niveau, âge, école, ville) est mis en cache sur cet appareil pour la vitesse, et supprimé à la déconnexion. Il ne quitte jamais votre navigateur.",
      on: "Autorisés",
      off: "Désactivés",
    },
    footer: {
      poweredBy: "Conçu par DRIHMIA | Votre assistant d'étude personnel",
      links: {
        faq: "Q&R",
        privacy: "Confidentialité",
        terms: "Conditions",
        contact: "Contact",
        cookies: "Gérer les cookies",
      },
    },
  },
  ar: {
    header: {
      title: "🌟مساعد الدراسة الذكي🌟",
      serverOnline: "الخادم متصل",
      signInButton: "🔐 تسجيل الدخول",
      feedback: "التعليقات",
      contact: "اتصل بالمعلم",
      chat: "الدردشة",
      messages: "الرسائل",
      resources: "المصادر",
      pricing: "الأسعار",
      faq: "أسئلة وأجوبة",
      toggleTheme: "تبديل السمة",
      toggleMenu: "فتح أو إغلاق القائمة",
      selectLanguage: "اختر اللغة",
    },
    consent: {
      label: "الموافقة على ملفات تعريف الارتباط",
      title: "خصوصيتك، خيارك",
      message: "نستخدم ملفات تعريف الارتباط لإبقائك مسجلاً، وحفظ إعداداتك، وفهم كيفية استعمال الموقع. أنت من يقرر ما يُسمح به.",
      detailsLink: "سياسة الخصوصية",
      acceptAll: "قبول الكل",
      rejectAll: "المتابعة بدون ملفات اختيارية",
      customize: "تخصيص",
      manage: "إدارة ملفات تعريف الارتباط",
      panelTitle: "إدارة ملفات تعريف الارتباط",
      panelIntro: "اختر ما تسمح به. تبقى الملفات الضرورية مفعّلة دائماً: هي ما يبقيك مسجلاً ويجعل الموقع يعمل.",
      trackingDisabledNote: "قياس الجمهور والإشهار معطّلان في بيئة التطوير المحلية. لا يتم إرسال أي شيء.",
      save: "حفظ اختياراتي",
      cancel: "إلغاء",
      necessary: "ضرورية",
      necessaryDesc: "جلسة تسجيل الدخول، الأمان، وملف الجلسة المجهول. مفعّلة دائماً.",
      analytics: "قياس الجمهور",
      analyticsDesc: "إحصائيات مجهولة (Google Tag Manager) لمعرفة الدروس المستعملة وإصلاح ما يتعطّل.",
      ads: "الإشهار",
      adsDesc: "ملفات إشهار تجعل الصيغة المجانية مجانية. للصيغة المجانية فقط.",
      adsNotAvailable: "لا إشهار في صيغتك: لا شيء للسماح به.",
      preferences: "التفضيلات",
      preferencesDesc: "تحفظ لغتك ومظهرك وصفك واختيارك للنموذج على هذا الجهاز.",
      restricted: "الموارد المجانية فقط",
      restrictedDesc: "يحدّ التطبيق من صفحة الموارد المجانية: لا محادثة، ولا حساب، ولا تتبع.",
      restrictedOn: "التطبيق محدود بالموارد المجانية.",
      leaveSite: "مغادرة الموقع",
      leaveSiteDesc: "أغلق هذه النافذة، أو عد لاحقاً وغيّر رأيك.",
      back: "رجوع",
      alwaysOn: "مفعّلة دائماً",
      localDataNote: "يُحفظ ملفك (المستوى، السن، المدرسة، المدينة) مؤقتاً على هذا الجهاز للسرعة ويُحذف عند تسجيل الخروج. لا يغادر متصفحك أبداً.",
      on: "مسموح",
      off: "معطّلة",
    },
    footer: {
      poweredBy: "مصنوع من قبل دريهمية | مساعدك الشخصي للدراسة",
      links: {
        faq: "أسئلة وأجوبة",
        privacy: "الخصوصية",
        terms: "الشروط",
        contact: "اتصل بنا",
        cookies: "إدارة ملفات تعريف الارتباط",
      },
    },
  },
};